import { I18n } from "@aws-amplify/core";
import moment from "moment-timezone";
import { forEach, get, max, size, filter, join, toLower, map } from "lodash";

import { calendarViews } from "../constants/common";
import { formatDate } from "./date";

// Return arrival event
export const getOccurrenceArrival = (occurrence) => {
  return get(
    filter(
      get(occurrence, ["events"]),
      (e) => get(e, ["type", "id"]) === 1 && e.active
    ),
    [0]
  );
};

// Return departure event
export const getOccurrenceDeparture = (occurrence) => {
  return get(
    filter(
      get(occurrence, ["events"]),
      (e) => get(e, ["type", "id"]) === 2 && e.active
    ),
    [0]
  );
};

export const getOccurrenceStart = (occurrence) => {
  return get(occurrence, ["when"]);
};

export const getOccurrenceEnd = (occurrence) => {
  let end = get(occurrence, ["when"]);
  end = moment(end).minutes(
    moment(end).minutes() +
    get(getOccurrenceDeparture(occurrence), ["relative_time_min"])
  );
  return end;
};

export const isOccurrenceInTimeSlot = (occurrence, slot) => {
  const start = get(occurrence, ["when"]);
  let end = get(occurrence, ["when"]);
  end = moment(end).minutes(
    moment(end).minutes() +
    get(getOccurrenceDeparture(occurrence), ["relative_time_min"])
  );

  if (
    moment(start).hours() === get(slot, ["start", "hours"]) &&
    moment(start).minutes() === get(slot, ["start", "minutes"]) &&
    moment(end).hours() === get(slot, ["end", "hours"]) &&
    moment(end).minutes() === get(slot, ["end", "minutes"])
  ) {
    return true;
  }

  return false;
};

export const getTimeSlotHeight = (occurrencesPerDay, slot, calendarView) => {
  const itemHeight = calendarView === calendarViews.daily ? 32 : 52;
  const minTimeSlotHeight = calendarView === calendarViews.daily ? 32 : 42;
  const counts = new Array(size(occurrencesPerDay)).fill(0);
  forEach(occurrencesPerDay, (day, i) => {
    forEach(get(day, ["occurrences"]), (group) => {
      if (isOccurrenceInTimeSlot(group, slot)) {
        counts[i]++;
      }
    });
  });
  return max([
    (max(counts) + (calendarView === calendarViews.daily ? 1 : 0.5)) *
    itemHeight,
    minTimeSlotHeight,
  ]);
};

export const getDayVisitorsCount = (dayOccurrences) => {
  let count = 0;
  forEach(dayOccurrences, (group) => {
    count += size(
      filter(
        get(getOccurrenceArrival(group), ["profiles"]),
        (p) => get(p, ["association_type", "id"]) === 2
      )
    );
  });
  return count;
};

export const getExceptions = (dayOccurrences, timeSlots) => {
  let exceptions = [];
  forEach(dayOccurrences, (occurrence) => {
    let inTimeSlot = false;
    forEach(timeSlots, (slot) => {
      if (isOccurrenceInTimeSlot(occurrence, slot)) {
        inTimeSlot = true;
      }
    });
    if (!inTimeSlot) exceptions.push(occurrence);
  });
  return exceptions;
};

export const getOverlapExceptionsCount = (exceptions) => {
  const overlapCounts = [];
  forEach(exceptions, (item) => {
    overlapCounts.push(getOverlapExceptionsCountSingle(item, exceptions));
  });

  if (size(overlapCounts) === 0) return 0;
  return max(overlapCounts) + 1;
};

export const getOverlapExceptionsCountSingle = (item, exceptions) => {
  let count = 0;
  forEach(
    filter(
      exceptions,
      (e) =>
        get(e, ["schedule", "id"]) !== get(item, ["schedule", "id"]) ||
        get(e, ["group_id"]) !== get(item, ["group_id"])
    ),
    (e) => {
      if (
        (getOccurrenceStart(item).valueOf() >=
          getOccurrenceStart(e).valueOf() &&
          getOccurrenceStart(item).valueOf() <=
          getOccurrenceEnd(e).valueOf()) ||
        (getOccurrenceEnd(item).valueOf() >= getOccurrenceStart(e).valueOf() &&
          getOccurrenceStart(item).valueOf() <= getOccurrenceEnd(e).valueOf())
      ) {
        count++;
      }
    }
  );
  return count;
};

export const getRecurrenceSentence = (periodicity, params) => {
  if (periodicity === "weekly") {
    return `${I18n.get("scheduler_repeatsEvery")} ${get(params, [
      "recurrence",
      "every",
    ])} ${I18n.get("dashboard_weeks")}  ${join(
      map(get(params, ["recurrence", "on"]), (i) => I18n.get(`common_${i}`)),
      ", "
    )} ${I18n.get("scheduler_starting")} ${toLower(
      I18n.get("scheduler_on")
    )} ${formatDate(
      get(params, ["startDate"]),
      "dddd, MMM. Do, YYYY"
    )}.`;
  } else if (periodicity === "daily") {
    return `${I18n.get("scheduler_repeatsEvery")} ${get(params, [
      "recurrence",
      "every",
    ])} ${I18n.get("scheduler_days")} ${I18n.get(
      "scheduler_starting"
    )} ${formatDate(get(params, ["startDate"]), "dddd, MMM. Do, YYYY")}.`;
  } else if (periodicity === "monthly") {
    return `${I18n.get("scheduler_repeatsEvery")} ${get(params, [
      "recurrence",
      "every",
    ])} ${I18n.get("scheduler_months")}  ${get(params, ["recurrence", "on"])} ${I18n.get(
      "scheduler_starting"
    )} ${toLower(
      I18n.get("scheduler_on")
    )} ${formatDate(get(params, ["startDate"]), "dddd, MMM. Do, YYYY")}.`;
  }
};
